import React, { useEffect } from 'react'
import { Container } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { fetchContactData } from '../../../../redux/action/homePage/homeContactUs'
import SmallLoading from '../../../../utils/SmallLoading'
import './style.scss'

const ContactUs = () => {
    const dispatch = useDispatch()
    const contactData = useSelector(state => state.contactData.contactData)
    const {t} = useTranslation();

    useEffect(() => {
        if(!contactData.id) {
            dispatch(fetchContactData())
        }
    }, [])

    if (contactData.address) {
        return (
            <Container>
                <div className='dashboard_contact mt-4'>
                    <div className='contactUs'>
                        <div>
                            <h4 className='text-center'>
                                {t("contact us")}
                            </h4>
                        </div>
                        <div className='contactUsContainer'>
                            <div className='contactUsLogo'>
                                <img src='./assets/img/contact-us.png' alt="contact-us" />
                            </div>
                            <div className='contactUsInfo'>
                                <div className='contact_item'><span className='contact_item_title'>{t("address")}: </span><span>{contactData.address ? contactData.address : <SmallLoading />}</span></div>
                                <div className='contact_item'><span className='contact_item_title'>{t("email")}: </span><span>{contactData.mail ? contactData.mail : <SmallLoading />}</span></div>
                                <div className='contact_item'><span className='contact_item_title'>{t("fax")}: </span><span>{contactData.fax ? contactData.fax : <SmallLoading />}</span></div>
                                <div className='contact_item'><span className='contact_item_title'>{t("Postal code")}: </span><span>{contactData.zip_code ? contactData.zip_code : <SmallLoading />}</span></div>
                                <div className='contact_item'><span className='contact_item_title'>{t("phone")}: </span><span>{contactData.phone ? contactData.phone : <SmallLoading />}</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        )
    } else {
        return ''
    }
    
}

export default ContactUs
